import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import musallah3 from "../assets/musallah3.jpg";
import 'bootstrap-icons/font/bootstrap-icons.css';
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import musallahclass from "../assets/musallahclass.jpg";

export const MusallahMobile = () => {
  return (
    <div style={{ backgroundColor: "#f4f4f4" }}>
      <MobileNavigationBar />
      <div
        style={{
          position: "relative",
          backgroundImage: `url(${musallah3})`,
          backgroundSize: "cover",
          backgroundPosition: "left 30% bottom 40%",
          height: "25vh",
          color: "white"
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: " rgba(36, 48, 53, 0.69) "
          }}
        ></div>

        <Container className="h-100">
          <Row className="h-100 align-items-center">
            <Col
              md={6}
              className="d-flex flex-column justify-content-center align-items-center text-center"
              style={{ position: "relative" }}
            >
              <h1 className="display-4 fw-bold mt-2">Musallah</h1>
              <p className="lead mt-2">
                A welcoming space for prayer, education, and community support where youth are empowered and families are supported.
              </p>
            </Col>

            <Col md={6}></Col>
          </Row>
        </Container>
      </div>

      <Container className="my-3 mb-5">
        <Row className="g-4">
          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-journal-text me-2"></i>
                Why the Musallah Matters
              </h4>
              <p>
                For over 15 years, the Musallah has helped children build lasting connections to the Quran.
                This space gives kids the tools to read, understand, and live by its teachings—not just learning the faith, but developing character.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-geo-alt-fill me-2"></i>
                A Convenient and Accessible Location
              </h4>
              <p>
                The Musallah is located within a low-income housing complex, making it easy for children to attend regularly without having to travel far to a mosque.
                Its central placement helps reduce the stress of accessibility for many families.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-person-check-fill me-2"></i>
                Supporting Youth in American Life
              </h4>
              <p>
                In addition to religious education, we guide children through the challenges of growing up in America.
                We teach them how to navigate their identities, uphold Islamic values, and become respectful, law-abiding members of society.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-people-fill me-2"></i>
                More than a Place to Pray
              </h4>
              <p>
                The Musallah is a space where refugee families come for support, and volunteers organize events for students.
                From applying mehndi for Eid to hygiene workshops that build life skills, we support our community in many ways.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-box-seam me-2"></i>
                Donation and Distribution Hub
              </h4>
              <p>
                Our on-site freezer allows us to collect and distribute meat donations from Qurbani, Aqeeqah, and general contributions.
                This ensures families in need have access to fresh, halal meat year-round.
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="p-4 bg-white shadow-sm rounded h-100">
              <h4 className="fw-bold mb-3 d-flex align-items-center" style={{ color: "#476537" }}>
                <i className="bi bi-mortarboard-fill me-2"></i>
                Tutoring and Educational Support
              </h4>
              <p>
                We provide tutoring sessions to help children succeed in school while staying grounded in their cultural and religious identity.
                Whether it’s homework help or Quran lessons, we meet them where they are.
              </p>
            </div>
          </Col>
        </Row>
        <div className="text-center mt-4">
          <hr className="my-4" style={{ borderTop: "2px solid #2e2e2eff" }} />
          <p style={{ fontSize: '14px' }}> <i>
            “I sincerely want to thank Br. Amjad and Hafiz. Abid for all the time, effort,
            and dedication they have put into teaching my kids Quran. It has been a wonderful
            journey, and they’ve learned so much over the past few years. We truly appreciate
            everything they have done for them and for us. A special thanks to Br. Amjad for
            his patience, encouragement, and the personal attention he has given to help each
            child grow. Wishing you both continued success and many blessings in all that you do.” </i>
            <br /> — O.S, parent
          </p>
        </div>
        <Row className="my-2 mx-2">
          <div style={{ position: "relative", width: "100%", paddingTop: "75%" }}>
            <img
              src={musallahclass}
              alt="Musallah Class"
              className="img-fluid rounded shadow-sm"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
            />
          </div>

        </Row>
      </Container>

      <MobileFooter />
    </div>
  );
};

export default MusallahMobile;
